
/**
 * Export `dimensions`.
 */

export const dimensions = {
  borderRadius: 6,
  snackbar: {
    maxWidth: 480
  }
};
